const scheduledServicesEventCardList = {
  servicesTitle: 'Services',
  servicesFilters: 'Services Filters',
  showMoreButton: 'Show More',
  notFound: 'No services found',
  assignMany: 'Assign many',
  assignOne: 'Assign one',
  selectAll: 'Select All',
  clearAll: 'Clear All',
};

export default scheduledServicesEventCardList;
